import { IconCheck } from "../icons";

interface Option {
  value: string;
  label: string;
}

interface Props {
  options: Option[];
  value: string[];
  onChange: (next: string[]) => void;
}

/** Seletor de múltipla escolha em cards clicáveis (caixa + rótulo) — mesma
 * linguagem visual do StatusCardSelector, no lugar de checkboxes nativos do
 * navegador (que destoam do tema escuro/claro do sistema). */
export default function ChecklistCardSelector({ options, value, onChange }: Props) {
  function toggle(val: string) {
    const next = value.includes(val)
      ? value.filter((x) => x !== val)
      : [...value, val];
    onChange(next);
  }

  return (
    <div className="checklist-selector">
      {options.map((opt) => {
        const active = value.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            className={`checklist-card${active ? " active" : ""}`}
            aria-pressed={active}
            onClick={() => toggle(opt.value)}
          >
            <span className="checklist-card-box">
              {active && <IconCheck size={13} />}
            </span>
            <span className="checklist-card-label">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
